<template>
  <div class="indexReport">
    <header>
      <el-form inline>
        <!-- <el-form-item label="公众号">
          <el-select
            v-model="selectQueryData.app_id"
            placeholder="全部"
            filterable
          >

            <el-option
              v-for="item in selectListData.data ? selectListData.data.account : null"
              :key="item.app_id"
              :label="item.account_name"
              :value="item.app_id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="公众号">
          <el-select
            v-model="selectQuerygroup.app_id"
            placeholder="全部"
            filterable
            @change="changeselect"
          >

            <el-option
              v-for="item in selectListData.data ? selectListData.data : []"
              :key="item.app_id"
              :label="item.account_name"
              :value="item.app_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="timesr"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions1"
            :default-value="timeDefaultShow"
            @change="getData"
          />
        </el-form-item>
        <el-form-item label="平台">
          <el-select
            v-model="selectQuerygroup.platform_id"
            clearable
            placeholder="全部"
            filterable
            @clear="clearr"
          >
            <el-option
              v-for="item in selectListDatar.data ? selectListDatar.data.platform : null"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="平台">
          <el-select
            v-model="selectQueryData.platform_id"
            placeholder="全部"
            filterable
          >
            <el-option
              v-for="item in selectListData.data ? selectListData.data.platform : null"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="书名">
          <el-select
            v-model="selectQueryData.novel_id"
            placeholder="全部"
            filterable
          >
            <el-option
              v-for="item in selectListData.data ? selectListData.data.novel : null"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="主角">
          <el-select
            v-model="selectQueryData.lead_id"
            placeholder="全部"
            filterable
          >
            <el-option
              v-for="item in selectListData.data ? selectListData.data.lead : null"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投放者">
          <el-select
            v-model="selectQueryData.user_id"
            placeholder="全部"
            filterable
          >
            <el-option
              v-for="item in selectListData.data ? selectListData.data.user : null"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="年份">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item label="投放版位">
          <el-select placeholder="全部投放版位" />
        </el-form-item> -->
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="handleReset"
        >重置</el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="handleDownloadone"
        >下载</el-button>
      </el-form>
      <div class="title">
        <!-- <div style="margin-right: 20px">上次更新时间为：{{ updateTime === null ? '0000-00-00 00:00:00' : updateTime }}</div>
        <div>
          <label>书城账号密码</label>
          <label>更新数据</label>
          <label>更新月表数据</label>
        </div> -->
      </div>
    </header>
    <main>
      <div class="form">
        <div class="title">
          <strong>关键指标明细表</strong>
          <strong class="magRig">（ <span class="green">首充回本</span><span class="yellow">复充回本</span><span class="blue">客单价</span></strong>
          <strong class="aggregateData">总成本：<span>{{ data ? data.account_recharge : 0 }}</span></strong>
          <strong class="aggregateData">总充值：<span>{{ data ? data.order_money : 0 }}</span></strong>
          <strong class="aggregateData">总回收率：<span>{{ data ? data.tcba : 0 }}%</span></strong>
          <!--          <strong class="aggregateData">总腾讯消耗：<span>{{}}</span></strong>-->
          <strong class="aggregateData">增长率：<span>{{ data ? data.ir : 0 }}%</span> ）</strong>
        </div>
        <!-- <div style="position: relative">
          <el-switch
            v-model="value"
            :width="100"
            active-color="#409EFF"
            inactive-color="rgb(191,191,191)"
          />
          <div
            v-if="value === true"
            style="color: #fff;position: absolute;top: 2px;left: 7px;"
          >首付金额开</div>
          <div
            v-else
            style="color: #fff;position: absolute;top: 2px;right: 7px;"
          >首付金额关</div>
        </div> -->
      </div>
      <!-- 备份 -->
      <div class="table">
        <el-table
          v-loading="loading"
          :data="tableData !== null ? tableData : null"
          border
          style="width: 100%"
        >

          <el-table-column
            fixed
            prop="date"
            align="center"
            :width="150"
          >
            <template slot="header">
              <label>日期</label>
              <!-- <i slot="reference" class="el-icon-s-comment rechargeButton" @click="handleShowRechargeData" /> -->
              <i
                slot="reference"
                class="el-icon-s-comment rechargeButton"
                @click="handleShowRechargeData"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.date }}
            </template>
          </el-table-column>

          <el-table-column
            prop="order_money"
            label="累计充值"
            align="right"
            sortable
            :width="150"
          />
          <template v-if="showRechargeDataFlag">
            <el-table-column
              v-for="(item, idx) in tableData[0].specially_day_data"
              :key="idx + Math.random()"
              prop="order_money"
              :label="'充值'+ '-' + rechargeDay[idx] + '天'"
              align="right"
              sortable
              :width="150"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.specially_day_data[idx].zc }}
                </span>
                <br>
                <span>
                  {{ scope.row.specially_day_data[idx].tcbi }}
                </span>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            :key="itemKey"
            prop="account_recharge"
            label="成本"
            align="right"
            sortable
            :width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.show">
                <input
                  v-model="cost"
                  v-focus
                  class="costInput"
                  autofocus="autofocus"
                  :placeholder="scope.row.account_recharge"
                  @keydown.enter="handlCostKeyDown"
                  @blur="handlCostKeyDown"
                >
              </span>
              {{ scope.row.account_recharge }}
              <!-- <span v-if="!scope.row.show" @dblclick="reSetCost(scope.row)">
                {{ scope.row.account_recharge }}
              </span> -->
              <!-- <i class="el-icon-edit editIcon" @click="reSetCost(scope.row)" /> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="tcba"
            label="回本率"
            align="center"
            :width="150"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.tcba }}%</div>
              <div>距今{{ scope.row.diff_today }}天</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ir"
            label="增长率"
            align="right"
            :width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.ir }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="profit"
            label="利润"
            align="right"
            :width="150"
          />
          <el-table-column
            v-for="(title, indx) in tableData ? tableData[0].data : null"
            :key="indx + 8888"
            align="center"
            :label="'第'+(indx + 1)+'天'"
            :width="230"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.data[indx].zc }}</div>
              <div>
                {{ scope.row.data[indx].tcb }}%
                <span class="powder magLfte">{{ scope.row.data[indx].tcbi }}%</span>
                <span class="red magLfte">{{ scope.row.data[indx].fans }}</span>
              </div>
              <div>
                <span class="green magRig">{{ scope.row.data[indx].scb }}%</span>
                <span class="yellow magRig">{{ scope.row.data[indx].fcb }}%</span>
                <span class="blue">{{ scope.row.data[indx].cao }}</span>
              </div>
              <div v-show="value">
                <span class="green magRig">{{ scope.row.data[indx].sc }}</span>
                <span class="yellow magRig">{{ scope.row.data[indx].fc }}</span>
                <span class="red magRig">{{ scope.row.data[indx].fib }}%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <pagination :total="total" :page.sync="pageData.page" :limit.sync="pageData.page_size" @pagination="getList" /> -->
      <pagination-right
        ref="pagination"
        :total="total"
        :page-sizes="[10]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        title="请选择下载日期"
        :visible.sync="dialogFormVisible"
        @close="close"
      >
        <el-form
          ref="downloadquery"
          label-width="180px"
          :model="downloadquery"
        >
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="downloadquery.start_date"
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="downloadquery.end_date"
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item label="颜色选择">
            <div class="block">
              <el-color-picker
                v-model="downloadquery.key_word_color"
                color-format="hex"
              />
            </div>
          </el-form-item>
          <div style="padding-left: 330px;">
            <el-button
              type="primary"
              @click="sumbitdown"
            >确定</el-button>
          </div>

        </el-form>

      </el-dialog>
    </main>
  </div>
</template>

<script>
// import Pagination from '@/components/Pagination'
import PaginationRight from '@/components/PaginationRight'
import { modifyCost, getDaygroup, exportGroup } from '@/api/report/reportDay'
import { getWechataccountlist } from '@/api/report/SelectData.js'
import dialogFocus from '@/layout/mixin/dialogFocus'
import { getSelectList } from '@/api/report/SelectData.js'
export default {
  name: 'PublicGroupReport',
  components: {
    // Pagination
    PaginationRight
  },
  mixins: [dialogFocus],
  data() {
    return {
      // data: null,
      timeDefaultShow: '',
      color: '',
      total: 0,
      value: false,
      loading: false,
      searchForm: [],
      tableData: null,
      updateTime: null,
      date: null,
      selectListData: [], // 筛选列表数据
      selectListDatar: [],
      selectQueryData: {
        // 请求数据
        app_id: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1
      },
      selectQuerygroup: {
        app_id: null,
        page: 1,
        start_date: null,
        end_date: null
      },
      downloadquery: {
        app_id: null,
        start_date: '',
        end_date: '',
        key_word_color: ''
      },
      dialogFormVisible: false,
      modifyCostQuery: {
        app_id: null,
        date: null,
        cost: null
      },
      rechargeDay: [3, 7, 15, 30, 45, 60], // 天数
      showRechargeDataFlag: false,
      visible: false,
      cost: null,
      index: -1,
      itemKey: 0,
      timesr: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      pickerOptions1: {
        disabledDate(v) {
          return v.getTime() > new Date().getTime() - (86400000 - (24 * 60 * 60 * 1000))
        }
      }

    }
  },
  // created() {
  //   this.getList()
  //   this.getSelectListData()
  // },
  created() {
    this.timeDefaultShow = new Date()
    this.timeDefaultShow.setMonth(new Date().getMonth() - 1)
    // this.getListdata()
  },
  mounted() {
    // 监听键盘按键事件
    const self = this
    this.$nextTick(() => {
      document.addEventListener('keyup', (e) => {
        // 此处填写你的业务逻辑即可
        if (e.keyCode === 27) {
          self.handlCostKeyDown()
        }
      })
    })
  },
  methods: {
    // 获取筛选列表
    getSelectListData() {
      getWechataccountlist().then(res => {
        this.selectListData = res
        this.selectQuerygroup.app_id = res.data[0].app_id
        this.downloadquery.app_id = res.data[0].app_id
        this.getListdata()
      })
    },
    // 修改成本
    postModifyCost() {
      modifyCost(this.modifyCostQuery).then(res => {
        this.getList()
      })
    },
    // 获取表格数据
    getList() {
      // this.datas = []
      // this.loading = true
      // getList(this.selectQueryData)
      //   .then(res => {
      //     this.tableData = res.data.list
      //     this.total = res.data.page_info.total
      //     this.updateTime = res.data.last_modify_time
      //     this.data = this.tableData[0]
      //     console.log(' 1 this.tableData', this.tableData)
      //     // 设置显示隐藏flag
      //     for (let i = 0; i < res.data.list.length; i++) {
      //       this.tableData[i].show = false
      //       this.tableData[i].select = i
      //     }
      //     console.log(' 2 this.tableData', this.tableData)
      //     this.loading = false
      //   })
    },
    getListdata() {
      // getDaygroup(this.selectQuerygroup).then(res => {
      //   console.log('res', res)
      // })
      this.datas = []
      this.loading = true
      getDaygroup(this.selectQuerygroup)
        .then(res => {
          this.tableData = res.data.list
          this.total = res.data.page_info.total
          this.updateTime = res.data.last_modify_time
          this.data = this.tableData[0]
          // 设置显示隐藏flag
          for (let i = 0; i < res.data.list.length; i++) {
            this.tableData[i].show = false
            this.tableData[i].select = i
          }
          this.loading = false
        })
    },
    // 获取筛选列表
    getSelectListDatar() {
      getSelectList().then(res => {
        console.log('re22222222s', res)
        this.selectListDatar = res
      })
    },
    fetchPageSize(e) {
      this.selectQuerygroup.page = e
      this.getListdata()
    },
    fetchCurrentPage(e) {
      this.selectQuerygroup.page = e
      this.getListdata()
    },
    // 搜索按钮
    handleSearch() {
      // console.log('search', this.selectQueryData)
      // this.getList()
      this.selectQuerygroup.page = 1
      this.$refs.pagination.select(1)
      this.getListdata()
    },
    // 重置按钮
    handleReset() {
      this.timesr = ''
      this.selectQuerygroup.page = 1
      this.selectQuerygroup.start_date = null
      this.selectQuerygroup.end_date = null
      this.selectQuerygroup.platform_id = null
      this.getListdata()
    },
    clearr() {
      console.log('111')
      this.selectQuerygroup.platform_id = null
    },
    // ondblclickCost(row) {
    //   console.log(123123132, row)
    //   this.$set(this.datas)
    //   this.index = -1
    //   for (let i = 0; i < this.datas.length; i++) {
    //     if (row[0].select === this.datas[i][0].select) {
    //       this.index = i
    //       this.datas[i][0].show = true
    //       return
    //     }
    //   }
    //   // this.datas[index][0].show = true
    //   console.log(row, this.index)
    // },
    postCostData() {
      if (this.cost === null) return
      if (!this.modifyCostQuery.app_id || !this.modifyCostQuery.date || !this.modifyCostQuery.cost) {
        this.$message({
          message: '请选择公众号再修改成本',
          type: 'error'
        })
        return
      } else {
        this.postModifyCost()
      }
    },
    // 修改成本回车确认
    handlCostKeyDown() {
      const i = this.index
      this.itemKey = Math.random()
      this.tableData[i].show = false
      this.modifyCostQuery.app_id = this.selectQueryData.app_id
      this.modifyCostQuery.date = this.tableData[i].date
      this.modifyCostQuery.cost = this.cost
      this.postCostData()
      this.cost = null
      this.index = -1
    },
    // 双击点击修改成本，单独修改table某项数据
    reSetCost(row) {
      for (let i = 0; i < this.tableData.length; i++) {
        // 挑出需要修改的那条数据
        if (row.select === this.tableData[i].select) {
          // 1. 把所有的input输入框隐藏
          this.tableData.forEach(item => {
            item.show = false
          })
          // 存放挑出来的那项数据的标识备用
          this.index = i
          // 2. 显示需要修改的那项数据的input输入框
          this.tableData[i].show = true
          // vue无法检测嵌套太深的对象数据的变化，实时试图更新因此失效，所以这里给修改项添加随机key用来强制更新视图
          this.itemKey = Math.random() * 10
          // 完成后跳出循环
          return
        }
      }
    },
    handleShowRechargeData() {
      if (!this.showRechargeDataFlag) {
        this.showRechargeDataFlag = true
      } else {
        this.showRechargeDataFlag = false
      }
    },
    // 下载按钮
    handleDownload({ clientX, clientY }) {
      this.$emit('download', {
        x: clientX,
        y: clientY
      }, this.selectQueryData)
    },
    handleDownloadone() {
      // this.dialogFormVisible = true
      this.sumbitdown()
      // console.log('666')
    },
    sumbitdown() {
      // if (this.selectQuerygroup.start_date === '') {
      //   this.$message.error('请选择开始时间')
      //   return
      // }
      // if (this.selectQuerygroup.end_date === '') {
      //   this.$message.error('请选择结束时间')
      //   return
      // }
      // console.log('this.downloadquery', this.downloadquery)
      exportGroup({
        app_id: this.downloadquery.app_id,
        start_date: this.selectQuerygroup.start_date,
        end_date: this.selectQuerygroup.end_date,
        platform_id: this.selectQuerygroup.platform_id
      }).then(res => {
        this.$message({
          message: `所有数据下载成功，任务ID为：${res.data.task_id}`,
          type: 'success'
        })
        this.dialogFormVisible = false
        this.clearquery()
      })
    },
    clearquery() {
      this.downloadquery.start_date = ''
      this.downloadquery.end_date = ''
      this.downloadquery.key_word_color = ''
      this.color = ''
    },
    handleChange(value) {
      const reg = /[0-9]\d+/g
      const getArr = value.match(reg)
      const hexStr = ((getArr[0] << 16) | (getArr[1] << 8) | getArr[2]).toString(16)
      this.downloadquery.key_word_color = hexStr
    },
    close() {
      this.clearquery()
    },
    changeselect(val) {
      this.selectQuerygroup.page = 1
      this.downloadquery.app_id = val
    },
    getData(date) {
      this.selectQuerygroup.start_date = date[0]
      this.selectQuerygroup.end_date = date[1]
    }
  }
}
</script>

<style scoped lang="less">
.el-dialog__wrapper /deep/ .el-dialog {
  width: 30%;
}
.indexReport {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      label {
        padding: 5px 10px;
        border: 1px solid #eee;
        background: #fff;
      }
    }
  }
  main {
    font-weight: 700;
    background: #fff;
    .form {
      display: flex;
      padding: 20px;
      background: #fff;
      border: 1px solid #eee;
      border-bottom: none;
      .switch {
        color: #fff;
        position: absolute;
        top: 2px;
        left: 7px;
      }
      .aggregateData {
        margin-left: 20px;
        span {
          color: #9d2631;
        }
      }
    }
    .table {
      .el-icon-s-comment {
        float: right;
        line-height: 2;
      }
    }
    .magRig {
      margin-right: 10px;
    }
    .magLfte {
      margin-left: 10px;
    }
    .powder {
      background: rgb(248, 216, 216);
    }
    .green {
      background: rgb(52, 229, 54);
    }
    .yellow {
      background: rgb(255, 247, 173);
    }
    .blue {
      background: rgb(158, 211, 252);
    }
    .red {
      background: #ffa500;
    }
    .rechargeButton {
      padding-right: 5px;
      cursor: pointer;
    }
    .costInput {
      border: 1px solid #ccc;
      width: 100px;
      height: 30px;
    }
    .editIcon {
      cursor: pointer;
    }
  }
}
</style>
